import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/page_icons/exercise.svg'
import _imports_1 from '../assets/arrow_left.svg'
import _imports_2 from '../assets/arrow_right.svg'


const _withScopeId = n => (_pushScopeId("data-v-5f8d5079"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "module-page" }
const _hoisted_2 = {
  key: 0,
  class: "overlay"
}
const _hoisted_3 = {
  key: 1,
  class: "lds-ring"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_8 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  id: "module-header",
  class: "row"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row elements-centering" }, [
    /*#__PURE__*/_createElementVNode("img", {
      id: "module-image-title",
      src: _imports_0,
      alt: "module logo"
    })
  ])
], -1))
const _hoisted_11 = {
  id: "module-title",
  class: "col-10"
}
const _hoisted_12 = {
  id: "container",
  class: "row"
}
const _hoisted_13 = {
  id: "breadcrumbs",
  class: "col-2"
}
const _hoisted_14 = {
  id: "page-container",
  class: "col-10"
}
const _hoisted_15 = {
  key: 0,
  class: "row justify-content-center alert alert-warning",
  role: "alert"
}
const _hoisted_16 = {
  key: 1,
  class: "row justify-content-center alert alert-warning",
  role: "alert"
}
const _hoisted_17 = {
  id: "page-title",
  class: "row"
}
const _hoisted_18 = {
  id: "elements-container",
  class: "row"
}
const _hoisted_19 = {
  key: 2,
  id: "buttons-container",
  class: "row"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow",
  src: _imports_1,
  alt: "left arrow"
}, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow",
  src: _imports_2,
  alt: "right arrow"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_Elements = _resolveComponent("Elements")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, { menus: true }),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_8))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.getModuleTitle(_ctx.module, _ctx.language)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_Breadcrumbs, {
          groups: _ctx.groups,
          module: _ctx.moduleId,
          page: _ctx.pageNumber,
          language: _ctx.language,
          "onUpdate:page": _cache[0] || (_cache[0] = ($event: any) => (_ctx.setupPage()))
        }, null, 8, ["groups", "module", "page", "language"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        (!_ctx.treatmentSet && !_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("HOME.TREATMENT_NOT_SET_1")), 1)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.treatmentSet && !_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("HOME.TREATMENT_NOT_SET_2")), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.getPageTitle(_ctx.page, _ctx.language)), 1)
        ]),
        _createElementVNode("div", _hoisted_18, [
          (_openBlock(), _createBlock(_component_Elements, {
            elements: _ctx.elements,
            moveToPage: _ctx.moveToPage,
            readOnly: _ctx.readOnly,
            key: _ctx.firstElement.id + _ctx.readOnly
          }, null, 8, ["elements", "moveToPage", "readOnly"]))
        ]),
        (!_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              (_ctx.firstPage && _ctx.page.id !== _ctx.firstPage.id)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "navigation-button navigation-button-back",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.moveToPreviousPage()))
                  }, [
                    _hoisted_20,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("MODULE_PAGE.BUTTONS.PREVIOUS")), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.lastPage && _ctx.page.id !== _ctx.lastPage.id)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "navigation-button navigation-button-forward",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.moveToNextPage()))
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t("MODULE_PAGE.BUTTONS.NEXT")) + " ", 1),
                    _hoisted_21
                  ]))
                : (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "navigation-button navigation-button-end-module btn primary",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.endModule()))
                  }, _toDisplayString(_ctx.$t("MODULE_PAGE.BUTTONS.END_MODULE")), 1))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}